import CRUDServiceOperations from "./CRUDServiceOperations";

class EntityMessageLogService extends CRUDServiceOperations {
  getEntityMessageLogs(pageInfo, sortInfo, callback, failureCallback) {
    const urlParams = this.urlFactory.constructPaginationAndFilteringUrlQueries(
      pageInfo,
      sortInfo
    );
    const url = this.getEntitiesUrl() + urlParams;
    return this.getEntityMessageLogsUrl(url, callback, failureCallback);
  }

  getEntityMessageLogsUrlPageable(
    urlLink,
    pageInfo,
    sortInfo,
    callback,
    failureCallback
  ) {
    const urlParams = this.urlFactory.constructPaginationAndFilteringUrlQueries(
      pageInfo,
      sortInfo,
      true
    );
    const url = urlLink + urlParams;
    return this.getEntitiesByUrl(url, callback, failureCallback);
  }

  getEntitiesUrl = () => {
    return this.urlFactory.entityMessageLogs();
  };
}

export default EntityMessageLogService;
